import * as React from 'react';

import cn from 'classnames';

import { testAttr } from '@utils';

import { IFormRowProps } from './types';

import * as s from './Form.scss';

export const FormRow = ({ children, className, isSmallIndent, testId }: IFormRowProps) => (
	<div
		className={cn(
			{
				[s.standard]: !isSmallIndent,
				[s.small]: isSmallIndent,
			},
			className,
		)}
		{...testAttr(testId)}
	>{children}</div>
);
